/*
 * Copyright (c) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, Input } from "@angular/core";

@Component({
    selector: "bci-table-container",
    templateUrl: "./table-container.component.html",
    styleUrls: ["./table-container.component.scss"],
    standalone: false
})
export class TableContainerComponent {
  @Input()
  emptyText: string;

  @Input()
  showEmptyState: boolean;
}
